import { createI18n } from 'vue-i18n';
import axios from 'axios';

export const i18n = createI18n({
  silentTranslationWarn: true,
  messageResolver: (obj, path) => obj[path]?.replaceAll('@', "{'@'}") ?? null,
});

const fetchTranslation = (locale, id) => axios.get(`/localization?locale=${locale}&company_id=${id}`);

export const setLocalization = (language, id = '') => {
  if (language) {
    localStorage.setItem('language', language);
  }

  const locale = localStorage.getItem('language') || navigator.language.split('-')[0];

  return fetchTranslation(locale, id)
    .then(({ data }) => {
      i18n.global.locale = locale;
      i18n.global.setLocaleMessage(locale, data);
      const tabTitle = localStorage.getItem('tab-title') || 'admin.management';
      if (tabTitle === 'return.portal') {
        document.title = `Reybex ${i18n.global.t('return.portal')}`;
      } else {
        document.title = i18n.global.t(tabTitle);
      }
    });
};

export const $t = i18n.global.t;
